<div class="mat-slider-group mat-slider-size" *ngFor="let item of slideData">
  <span class="mat-slider-label">{{item.sliderlabel}}</span><mat-slider [min]="item.min" [max]="item.max" [step]="item.step" [value]="item.value" [ngClass]="'mat-slider-' + item.theme"></mat-slider>
</div>
